import { createPdfLineById } from "../shared";

export const IRAS_MAIN_COMP_LINES = [
  {
    id: "net_profit_before_tax",
    label: "Net Profit / (Loss) before Tax",
    type: "result",
  },
  {
    id: "separate_source_income_expenses",
    label: "Add/(Less): Separate Source Income / (Expenses)",
    type: "section",
  },
  {
    id: "non_taxable_income",
    label: "Less: Deductible / Non-Taxable Items",
    type: "section",
  },
  {
    id: "non_tax_deductible_expenses",
    label: "Add: Non-Tax Deductible Expenses",
    type: "section",
  },
  {
    id: "adjusted_profit_before_other_deductions",
    label: "Adjusted Profit / (Loss) before Further Deductions",
    type: "result",
  },
  {
    id: "section_14n",
    label: "Less: Deductions for R&R works under S14N",
    type: "section",
  },
  {
    id: "further_deductions",
    label: "Add/(Less): Other Further Deductions",
    type: "section",
  },
  {
    id: "balancing_charge",
    label: "Add: Balancing Charge",
    type: "section",
  },
  {
    id: "adjusted_profit_before_capital_allowances",
    label: "Adjusted Profit / (Loss) before Capital Allowances",
    type: "result",
  },
  {
    id: "unutilised_ca_bf",
    label: "Add/(Less): Unutilised Capital Allowances b/f",
    type: "section",
  },
  {
    id: "current_year_ca",
    label: "Add/(Less): Current Year Capital Allowances",
    type: "section",
  },
  {
    id: "total_after_capital_allowances",
    label: "Adjusted Profit / (Loss) after Capital Allowances",
    type: "result",
  },
  {
    id: "add_other_sourced_income",
    label: "Add: Separate Source Income",
    type: "section",
  },
  {
    id: "adjusted_profit_before_losses",
    label: "",
    type: "result",
  },
  {
    id: "unutilised_losses_bf",
    label: "Less: Unutilised Losses b/f",
    type: "section",
  },
  {
    id: "total_before_donations",
    label: "Adjusted Profit / (Loss) after Losses",
    type: "result",
  },
  {
    id: "unutilised_donations_bf",
    label: "Less: Unutilised Donations b/f",
    type: "section",
  },
  {
    id: "current_year_donations",
    label: "Less: Current Year Donations",
    type: "section",
  },
  {
    id: "total_after_donations",
    label: "Chargeable Income Before Exempt Amount",
    type: "result",
  },
];

export const IRAS_MAIN_COMP_LINE_BY_ID =
  createPdfLineById(IRAS_MAIN_COMP_LINES);
